import BaseModule from "@/components/site-builder/BaseModule";
import CallToActionGroup from "@/components/site-builder/CallToActionGroup";
import type { ButtonGroupModuleType } from "./types";
import s from "./ButtonGroupModule.module.css";

export interface ButtonGroupModuleProps {
  module: ButtonGroupModuleType;
}

export default function ButtonGroupModule(props: ButtonGroupModuleProps) {
  const { module } = props;
  const {
    body: { buttons, buttonsAlignment },
  } = module;

  return (
    <BaseModule module={module}>
      <CallToActionGroup
        buttons={buttons}
        position={buttonsAlignment}
        className={s.group}
      />
    </BaseModule>
  );
}
